import { z } from "zod";

const envSchema = z.object({
  VITE_GOOGLE_MAPS_API: z.string(),
  VITE_API_URL: z.url(),
  VITE_PUSHER_KEY: z.string(),
  VITE_PUSHER_CLUSTER: z.string(),
});

export const env = envSchema.parse(import.meta.env);
